import { Col } from "react-bootstrap";
import { Box, Tooltip, Button, Typography } from "@mui/material";

export default function ToolbarBtn(props) {
  const {
    tooltipId,
    tooltipTitle,
    tooltipPlacement,
    btnId,
    btnClassName,
    btnVariant,
    btnSubVariant,
    btnDisabled,
    onClick,
    icon,
    btnLabel,
    width,
    startIconEnabled,
    buttonStartIcon,
  } = props;
  return (
    <Col xs="auto">
      <Box className="bx">
        <Tooltip
          id={tooltipId}
          title={tooltipTitle}
          placement={tooltipPlacement ?? "bottom"}
        >
          <Button
            className={btnClassName ?? ""}
            id={btnId ?? ""}
            disabled={btnDisabled}
            variant={btnVariant ?? "toolbar-btn"}
            sub_variant={btnSubVariant ?? "primary"}
            owner="admin"
            onClick={onClick ?? undefined}
            sx={
              !startIconEnabled && !buttonStartIcon
                ? {
                    ".MuiButton-startIcon": {
                      margin: 0,
                    },
                  }
                : {}
            }
            startIcon={
              startIconEnabled ? (
                buttonStartIcon ? (
                  buttonStartIcon
                ) : (
                  <Box sx={{ width: 18, height: 18 }} />
                )
              ) : (
                <></>
              )
            }
          >
            <Typography
              variant="subtitle2"
              owner="admin"
              className="btn-lh"
              weight="regular"
            >
              {width && width <= 1200 ? icon : btnLabel}
            </Typography>
          </Button>
          {props.children}
        </Tooltip>
      </Box>
    </Col>
  );
}
